$.getMultiScripts = function (arr) {
    var _arr = $.map(arr, function (src) {
        return $.getScript(src);
    });
    _arr.push($.Deferred(function (deferred) {
        $(deferred.resolve);
    }));
    return $.when.apply($, _arr);
};
$.fn.serializeFormJSON = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        }
        else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};
$.fn.epcSlider = function (options) {
    var settings = $.extend({
        verticalAlign: false,
        min: 0,
        max: 700,
        val: 0
    }, options);
    var container = this;
    var epcMark = $('<div>', { 'class': 'epc-mark', html: settings.val });
    var slider = $('<div>');
    settings.val = settings.val > settings.max
        ? settings.max
        : settings.val < settings.min
            ? settings.min
            : settings.val;
    if (settings.verticalAlign) {
        epcMark.css('margin-bottom', '-23px').css('left', '-9px').css('bottom', (settings.val / (settings.min + settings.max)) * 100 + '%');
        slider.addClass('vertical-slider');
    }
    else {
        epcMark.css('margin-left', '-23px').css('top', '-5px').css('left', (settings.val / (settings.min + settings.max)) * 100 + '%');
        slider.addClass('horizontal-slider');
    }
    container.empty().append(epcMark).append(slider).addClass('epc').data('min', settings.min).data('max', settings.max);
    return container;
};
